import { render, staticRenderFns } from "./MagenteGrid.vue?vue&type=template&id=2de58ee6"
import script from "./MagenteGrid.vue?vue&type=script&lang=js"
export * from "./MagenteGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports